const emptyFunction = (): void => {
  /* empty */
};

type Callback<D> = D extends undefined ? () => void : (data: D) => void;

export type Observer<S = undefined, E = undefined, F = undefined> = {
  next: Callback<S>;
  error: Callback<E>;
  finalize?: Callback<F>;
};

export type PartialObserver<S = undefined, E = undefined, F = undefined> = Partial<Observer<S, E, F>>;

export function partialToRequiredObserver<S, E, F>(partial: PartialObserver<S, E, F>): Observer<S, E, F> {
  return {
    next: partial.next ?? (emptyFunction as Callback<S>),
    error: partial.error ?? (emptyFunction as Callback<E>),
    finalize: partial.finalize ?? (emptyFunction as Callback<F>),
  };
}
